module.exports = __webpack_public_path__ + "videos/legacy_xl.2710705.mp4";